import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar, faPaperPlane, faCommentDots } from "@fortawesome/free-solid-svg-icons"; // Added faCommentDots for header
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App"; // Assuming AuthGuard is correctly implemented
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddComment = () => {
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0); // Initially no stars selected
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  // const userDataString = localStorage.getItem("user"); // This is not used, removed for cleaner code
  // const userData = JSON.parse(userDataString); // This is not used, removed for cleaner code
  // const userId = userData.unique; // This is not used, removed for cleaner code
  const propertyId = localStorage.getItem("specificPropertyId");

  const handleStarClick = (value) => {
    setRating(value === rating ? 0 : value); // Toggle the rating
  };

  const handleSubmit = async () => {
    // Basic validation
    if (!comment.trim()) {
      toast.error("Comment cannot be empty.");
      return;
    }
    if (rating === 0) {
      toast.error("Please provide a star rating.");
      return;
    }
    if (!propertyId) {
        toast.error("Property not found. Cannot add comment.");
        navigate("/user/myapartment"); // Redirect to a safe page
        return;
    }


    try {
      const response = await axios.post(
        `https://backend.inyumba.co.ke/iNyumba/admin/comments/add/${propertyId}`,
        {
          comments: comment,
          ratings: rating,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.response);
      navigate("/user/myapartment");
    } catch (error) {
      console.error("Error adding comment:", error);
      if (error.response && error.response.data && error.response.data.response) {
        toast.error(error.response.data.response);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <AuthGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-blue-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 p-8 text-center space-y-8 animate-fade-in-up">
          <div className="text-center">
            <FontAwesomeIcon icon={faCommentDots} className="text-indigo-500 text-6xl mx-auto mb-4" />
            <h1 className="text-4xl font-extrabold text-gray-900 mb-2">
              Share Your Feedback
            </h1>
            <p className="text-gray-600 text-lg">
              We'd love to hear your thoughts on this property!
            </p>
          </div>

          <div className="space-y-6 text-left">
            {/* Comment Input */}
            <div>
              <label htmlFor="comment" className="block text-gray-700 text-lg font-semibold mb-2">
                Your Comment
              </label>
              <textarea
                id="comment"
                className="block w-full py-3 px-4 border-2 border-gray-200 rounded-xl placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-400 focus:border-indigo-400 sm:text-lg transition-all duration-200 resize-y"
                rows="5"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>

            {/* Rating Input */}
            <div>
              <label className="block text-gray-700 text-lg font-semibold mb-2">
                Your Rating
              </label>
              <div className="flex items-center justify-center sm:justify-start">
                {[1, 2, 3, 4, 5].map((value) => (
                  <FontAwesomeIcon
                    key={value}
                    icon={value <= rating ? solidStar : regularStar}
                    className={`cursor-pointer text-3xl mx-1 transition-colors duration-200 
                                  ${value <= rating ? "text-yellow-400" : "text-gray-300"}
                                  hover:text-yellow-500`}
                    onClick={() => handleStarClick(value)}
                  />
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <div>
              <button
                className="flex items-center justify-center space-x-3 w-full py-3 px-6 rounded-xl text-xl font-bold transition-all duration-300 ease-in-out shadow-lg
                           bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                onClick={handleSubmit}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
                <span>Submit Comment</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </AuthGuard>
  );
};

export default AddComment;